// ABOUTME: Modal for adding a new API connection (webshopcredential of type api).
// ABOUTME: User only needs to provide a name; all sync options default to true.
import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { useCreateWebshopCredentialsMutation } from "../../../newapi/webshop/webshopSlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import { yupRequired } from "../../../utils/validation";

const MAddApiConnection = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [createWebshopCredentials, { isLoading }] = useCreateWebshopCredentialsMutation();

    const [apiConnectionInfo, setApiConnectionInfo] = useState({
        description: "",
    });

    const [fieldErrors, setFieldErrors] = useState({});

    const schema = yup.object().shape({
        description: yupRequired('description', t),
    });

    const handleClose = () => {
        setApiConnectionInfo({ description: "" });
        setFieldErrors({});
        props.handleClose();
    };

    const handleChange = (key, value) => {
        setApiConnectionInfo({
            ...apiConnectionInfo,
            [key]: value
        });
        setFieldErrors({
            ...fieldErrors,
            [key]: ''
        });
    };

    const handleSave = async () => {
        try {
            if (isLoading) return;

            setFieldErrors({});
            await schema.validate(apiConnectionInfo, { abortEarly: false });

            const payload = {
                description: apiConnectionInfo.description,
                webshop_type: "api",
                syncOrders: "true",
                syncStock: "true",
                syncProducts: "true",
                syncCreateProducts: "true",
                credentials: {},
            };

            const data = await createWebshopCredentials(payload).unwrap();
            showToastMessagePostRequest(t, data);
            handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                const errors = err.inner.reduce((acc, currentError) => ({
                    ...acc,
                    [currentError.path]: currentError.message
                }), {});
                setFieldErrors(errors);
            } else {
                showToastMessageRequestError(t("create_failed"), t, err);
            }
        }
    };

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box
                sx={{
                    textAlign: "center",
                    paddingY: 4,
                    paddingX: 5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1
                }}>
                <Subheading>{t("add_api_connection")}</Subheading>
            </Box>

            <Box
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding: 3,
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2
                }}
            >
                <Box
                    sx={{
                        width: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 7
                    }}
                >
                    <Box sx={{ width: 120 }}>
                        <Text>{t("name")}</Text>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                            borderRadius: 4,
                            display: "flex",
                            height: 32
                        }}
                    >
                        <ShValidatedInput
                            name="description"
                            value={apiConnectionInfo.description}
                            onChange={handleChange}
                            error={fieldErrors.description}
                        />
                    </Box>
                </Box>
            </Box>

            <Box
                component="footer"
                sx={{
                    display: "flex",
                    width: 1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    alignItems: "center",
                    paddingRight: 3,
                    zIndex: 1058,
                    position: "relative",
                    paddingTop: 2,
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius: 24,
                    borderBottomRightRadius: 24,
                    justifyContent: "space-between",
                    "@media screen and (max-width: 47.9375em)": {
                        paddingRight: 0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                        variant="contained"
                        onClick={handleSave}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    );
};

export default MAddApiConnection;
